// extracted by mini-css-extract-plugin
export default {"optionLabel":"optionLabel---zhjF0","totalRecordsLabel":"totalRecordsLabel---d6pEu"};